import { Component, effect, inject, signal } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { takeUntil } from 'rxjs';
import { VehicleMaintenanceSearchDto } from '@splitsecondconnect/ultramarine-shared';

import { BaseLinkCardComponent } from '../../../../../shared/base-classes/base-link-card.component';
import { LinkCardContainerComponent } from '../../../../../shared/components/containers/link-card-container/link-card-container.component';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';
import { SelectItem } from '../../../../../shared/models/select-item.type';
import { ExpectedAtPillComponent } from 'app/shared/components/expected-at-pill/expected-at-pill.component';
import { VehicleMaintenancesService } from '../../vehicle-maintenances.service';
import { mapDtoToModelVehicleMaintenances } from '../../mappers/search-dto-to-model.mapper';

@Component({
	selector: 'app-vehicle-maintenance-link-card',
	templateUrl: 'vehicle-maintenance-link-card.component.html',
	standalone: true,
	imports: [
		LinkCardContainerComponent,
		TranslocoModule,
		ExpectedAtPillComponent,
	],
	host: {
		class: 'w-full',
	},
})
export class VehicleMaintenanceLinkCardComponent extends BaseLinkCardComponent<
	SelectItem<VehicleMaintenanceSearchDto>
> {
	moduleUrl = signal(ModulesEnum.VEHICLE_MAINTENANCES);
	#service = inject(VehicleMaintenancesService);

	constructor() {
		super();

		this.module = ModulesEnum.VEHICLE_MAINTENANCES;
		effect(() => {
			this.pingerSignal();
			if (!this.id()) {
				this.link.set(null);
				this.isLoading.set(true);
				return;
			}
			this.#service
				.getSearchResults('', [this.id()])
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((res) => {
					if (!res.data) {
						return;
					}
					this.isLoading.set(false);
					this.link.set(mapDtoToModelVehicleMaintenances(res.data)[0]);
				});
		});
	}
}
